import * as mbase from '../base/mbase.js';
var getQueryStr = mbase.getQueryStr;
import Dom from '../base/mdom.js';
var _aoExports  = {
    isCSR : mbase.isCSR
};
const PlatformMap = {
    'iOS': 'iOS',
    'Android': 'Android',
    'Mac': 'Mac',
    'Windows': 'Windows'
}
/*
    @desc  将客户端版本转换成16进制的版本
*/
const version2HexVersion = (clientVersion, platform) => {
    const versions = clientVersion.split('.').slice(0, 3);
    /**
       * 从小括号拿不到，自己根据版本号转换
       * 7.0.14 -> 0x27000E00
       * 2 7 00 0E 00
          2: Android, iOS是1
          7: major
          00: minor
          0E: rev
          00: patch
      */
    const hexVersions = ['0x'];
    // 1: iOS/Mac，2: Android,  6: windows
    if (platform === PlatformMap.iOS || platform === PlatformMap.Mac) {
      hexVersions.push('1');
    } else if( platform === PlatformMap.Windows ){
      hexVersions.push('6');
    } else {
      hexVersions.push('2');
    }
    for (let i = 0; i < 3; i++) {
      const version = versions[i] || '';
      // substr(0,2)应对奇葩版本号, 如正常是6.5.0_960, 结果变成 6.5.960版本了, 坑
      const t = parseInt(version.substr(0, 2), 10);
      if (i === 0) { // major 1位
        if (!t || isNaN(t)) {
          hexVersions.push('0');
        } else if (t < 0x10) {
          hexVersions.push(t.toString(16));
        } else {
          hexVersions.push('f');
        }
      } else { // minor | rev 两位
        if (!t || isNaN(t)) {
          hexVersions.push('00');
        } else if (t < 0x10) {
          hexVersions.push('0');
          hexVersions.push(t.toString(16));
        } else if (t >= 0x10 && t < 0x100) {
          hexVersions.push(t.toString(16));
        } else {
          hexVersions.push('ff');
        }
      }
    }
    // patch 两位
    hexVersions.push('00');
    return Number(hexVersions.join(''));
};

const getPlatform = (ua) => {
    if (/(iPhone|iPad|iPod|iOS)/i.test(ua)) {
      return PlatformMap.iOS;
    }
    if (/WindowsWechat/i.test(ua)) {
      return PlatformMap.Windows;
    }
    if (/MacWechat/i.test(ua)) {
      return PlatformMap.Mac;
    }
    return PlatformMap.Android;
};

const getClientVersion = (hexClientVersion, needPatch) => {
    if (!hexClientVersion) {
      return '';
    }
    const unit = Math.pow(16, 2);
    let version = hexClientVersion;
    const patch = version % unit;
    version = Math.floor(version / unit);
    const rev = version % unit;
    version = Math.floor(version / unit);
    const minor = version % unit;
    version = Math.floor(version / unit);
    const major = version % 16;
    return (needPatch && patch > 0) ? `${major}.${minor}.${rev}.${patch}` : `${major}.${minor}.${rev}`;
};

var _sUserAgent, _mbiOS, _mbAndroid, _isWechat, _isPcWechat, _isPC, _isMSDK, _isAndroidMSDK, _isIosMSDK, _isXweb, _isX5, _isWKweb, _reportObj;
var _isMacWechat, _isWindowsWechat, _platform;
if(!_aoExports.isCSR) {
    _sUserAgent = Dom.window.navigator.userAgent;
    _platform   = getPlatform(_sUserAgent);
    _mbiOS      = _platform === PlatformMap.iOS;
    _mbAndroid  = _platform === PlatformMap.Android;
    _isWechat   = _sUserAgent.indexOf('MicroMessenger') != -1;
    _isMacWechat = _platform === PlatformMap.Mac;
    _isWindowsWechat = _platform === PlatformMap.Windows;


    _isPcWechat = _isMacWechat || _isWindowsWechat;
    _isPC       = false;

    _isMSDK     = /(MSDK)/i.test(_sUserAgent);
    _isAndroidMSDK = /MSDK\/[\d\.]{1,}?a/i.test(_sUserAgent);
    _isIosMSDK  = /MSDK\/[\d\.]{1,}?i/i.test(_sUserAgent);
    _isXweb     = /XWEB/i.test(_sUserAgent);
    _isX5       = /TBS/i.test(_sUserAgent);
    _isWKweb    = /WKType/i.test(_sUserAgent);
    _reportObj  = {};
    if (!/Android|BlackBerry|IEMobile|iPhone|iPad|iPod/.test(_sUserAgent)) {
        _isPC = true;
    }
    _aoExports.isiOS        = _mbiOS || _isIosMSDK;

    _aoExports.isLuggage    = /Luggage/i.test(_sUserAgent);
    _aoExports.isPad        = /iPad/i.test(_sUserAgent);
    _aoExports.isiOS9       = _mbiOS && _sUserAgent.indexOf('OS 9') != -1;
    _aoExports.isiOS10 = _mbiOS && _sUserAgent.indexOf('OS 10') != -1;
    _aoExports.isiOS11 = _mbiOS && _sUserAgent.indexOf('OS 11') != -1;
    _aoExports.isAndroid    = _mbAndroid || _isAndroidMSDK;
    _aoExports.isWechat     = _isWechat;
    _aoExports.isPcWechat   = _isPcWechat;
    _aoExports.isMacWechat  = _isMacWechat;
    _aoExports.isWindowsWechat = _isWindowsWechat;
    _aoExports.isPC         = _isPC;
    _aoExports.isDev        = process.env.NODE_ENV === 'development';

    _aoExports.isMSDK               = _isMSDK;
    _aoExports.isAndroidMSDK        = _isAndroidMSDK;
    _aoExports.isIosMSDK            = _isIosMSDK;
    _aoExports.isXweb               = _isXweb;
    _aoExports.isX5                 = _isX5;
    _aoExports.isWKweb              = _isWKweb;
    _aoExports.isIosLiuhai          = _mbiOS && (window.screen.height >= 812);
    _aoExports.isTestEnv            = function() {
        return new Promise(function(resolve) {
            if( !_isWechat || !mbase.getValue(WXGAME, "WxBridge.VerifyJsapiModule")) { // 非微信，或者没有使用commlib
                resolve(false)
                return
            }
            WXGAME.WxBridge.VerifyJsapiModule.callAfterLoaded(data => {
                if( data && data.isTestEnv ) {
                    resolve(true)
                }else {
                    resolve(false)
                }
            })
        })
    }; // 是否测试环境
    _aoExports.isTestData           = !!getQueryStr("is_test_data"); // 是否测试数据 
    
    // 是否是darkmode
    _aoExports.isDarkMode = false;

    const onDarkModeChangeFns = []
    // 记录下darkmode改变时，需要调用的函数
    _aoExports.onDarkModeChange = function (callback) {
        callback() // 先调用一次
        onDarkModeChangeFns.push(callback);
    }

    function initDarkModeListener() {
        if(!window.matchMedia) return;
        const mql = window.matchMedia('(prefers-color-scheme: dark)'); // 匹配媒体查询
        const switchToDarkmode = ({ // 切换为darkmode时do something
            matches
            }) => {
            if (location.search.indexOf('darkmode=1') !== -1) {
                return
            }
            if (matches) {
                // dark mode
                _aoExports.isDarkMode = true;
            } else {
                // not dark mode
                _aoExports.isDarkMode = false;
            }
            onDarkModeChangeFns.forEach(fn => fn());
        };
        mql.addListener(switchToDarkmode); // 监听darkmode切换
        switchToDarkmode(mql); // 先手动执行一次

        // 首次进入时，querystring中的参数优先级最高
        if (location.search.indexOf('darkmode=1') !== -1) {
            _aoExports.isDarkMode = true;
        }
        if (location.search.indexOf('darkmode=0') !== -1) {
            _aoExports.isDarkMode = false;
        }
        // END querystring中的参数优先级最高
    }
    initDarkModeListener();

    _aoExports.deviceType = (function() {
        var _sUserAgent = Dom.window.navigator.userAgent;
        var dtype = {
            'iPhone': 0,
            'iPad': 0,
            'iPod': 0,
            'Android': 0
        };
        var res = {};
        for (var p in dtype) {
            var reg = new RegExp(p, 'i');
            res[p] = reg.test(_sUserAgent) ? p : dtype[p];
            if(res[p]) {
                return p.toLowerCase();
            }
        }
        // 没有的就传空
        return '';
    })();

    /* 暴露接口1 增加判断IOS是多少 大版本的功能。 */
    (function(_ao){
        var iOSVersion   = _sUserAgent.match(/OS[\s]+(\d{1,2}?)_\d{1}/);
        iOSVersion = iOSVersion || [];
        if(iOSVersion.length >= 2){
            var _v = parseInt(''+iOSVersion[1]);
            _ao.iOSVersion = isNaN(_v) ? 0 : _v;
        }
    })(_aoExports);
}else{
    let systemInfo = mbase.getCSR().getSystemInfo();
    _platform   = getPlatform(systemInfo.system);
    _sUserAgent = '',
    _mbiOS      = /ios/i.test(systemInfo.system),
    _mbAndroid  = /android/i.test(systemInfo.system),
    _isWechat   = true,
    _isPcWechat = false,
    _isPC       = false,

    _isMSDK     = false,
    _isAndroidMSDK = false,
    _isIosMSDK  = false,
    _isXweb     =  /android/i.test(systemInfo.system),
    _isX5       = false,
    _isWKweb    = /ios/i.test(systemInfo.system),
    _reportObj  = {};
    _aoExports.isiOS        = _mbiOS || _isIosMSDK;

    _aoExports.isLuggage = false;
    _aoExports.isPad     = /ipad/i.test(systemInfo.model);
    _aoExports.isiOS9    = /OS 9/i.test(systemInfo.system);
    _aoExports.isiOS10   = /OS 10/i.test(systemInfo.system);
    _aoExports.isiOS11   = /OS 11/i.test(systemInfo.system);
    _aoExports.isAndroid    = _mbAndroid;
    _aoExports.isWechat     = true;
    _aoExports.isPcWechat   = false;
    _aoExports.isMacWechat  = false;
    _aoExports.isWindowsWechat = false;
    _aoExports.isPC         = false;
    _aoExports.isDev        = process.env.NODE_ENV === 'development';

    _aoExports.isMSDK               = _isMSDK;
    _aoExports.isAndroidMSDK        = _isAndroidMSDK;
    _aoExports.isIosMSDK            = _isIosMSDK;
    _aoExports.isXweb               = _isXweb;
    _aoExports.isX5                 = _isX5;
    _aoExports.isWKweb              = _isWKweb;
    _aoExports.isIosLiuhai          = false;

    _aoExports.isDarkMode       = !!systemInfo.isDarkMode;
    _aoExports.onDarkModeChange = function () {};
    _aoExports.deviceType       = _aoExports.isPad ? 'ipad' : _mbiOS ? 'iphone' : 'android';

    _aoExports.getCSR = mbase.getCSR;
}

/*
    @desc   对比两个微信版本
    version > versionNext  -> 返回 大于0的数
    version = versionNext  -> 返回 等于0
    version < versionNext  -> 返回 小于0的数
*/
_aoExports.versionCompare = function(version, versionNext) {
    var _version     = version.split('.');
    var _versionNext = versionNext.split('.');
    for (var i = 0, len = Math.min(_version.length, _versionNext.length); i < len; i++) {
        var left = parseInt(_version[i]) - parseInt(_versionNext[i]);
        if (0 != left) {
            return left;
        }
    }
    return _version.length - _versionNext.length;
};

/* 统一获取微信的版本  */
_aoExports.clientVersion = function(needDot) {
    var version     = '',
        udots       = [1000, 100, 1],
        uversion    = 0;

    if(mbase.isCSR) {
        version = mbase.getCSR().getSystemInfo().clientVersion; // 7.0.15
    }else{
        version = getClientVersion(_aoExports.getHexClientVersion(), _platform)
    }

    /*
        如果需要....，那就用它。。。
    */
    if(needDot){
        return version;
    }

    version = version.split('.').slice(0, 3);
    for (var i = 0, il = version.length; i < il; i++) {
        //substr(0,2)应对奇葩版本号, 如正常是6.5.0_960, 结果变成 6.5.960版本了, 坑
        var t = parseInt(version[i].substr(0, 2));
        if (!isNaN(t)) {
            uversion += t * udots[i];
        }
    }
    return uversion;
};

/* 获取微信16进制版本号
    对于userAgent：MicroMessenger/7.0.12(0x17000c2c)
    1. 先从小括号里面拿，即0x17000c2c
    2. 没有小括号，用7.0.12转换
*/
_aoExports.getHexClientVersion = function(){
    let platform = _platform
    if( mbase.isCSR ) {
        return version2HexVersion(mbase.getCSR().getSystemInfo().clientVersion, platform)
    }
    let ua = Dom.window.navigator.userAgent || Dom.window.navigator.wxuserAgent || "";
    if (platform === PlatformMap.Mac) {
        /* user-agent 示例
          Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/605.1.15 (KHTML, like Gecko)
          MicroMessenger/6.8.0(0x16080000) MacWechat/3.4.1(0x13040111) Safari/605.1.15 NetType/WIFI
        */
        const versionReg = /MacWechat\/([\d\.]+)(?:\((0x[0-9a-fA-F]+)\))/i;
        const match = versionReg.exec(ua);
        if (!match) {
          return 0;
        }
        return Number(match[2]);
    } if (platform === PlatformMap.Windows) {
        /* user-agent 示例
            User-Agent: Mozilla/5.0 (Windows NT 6.1; WOW64) AppleWebKit/537.36 (KHTML, like Gecko)
            Chrome/81.0.4044.138 Safari/537.36 NetType/WIFI MicroMessenger/7.0.20.1781(0x6700143B) WindowsWechat(0x6307001e)
        */
        const versionReg = /WindowsWechat\/(?:\((0x[0-9a-fA-F]+)\))/i;
        const match = versionReg.exec(ua);
        if (!match) {
            return 0;
        }
        return Number(match[1]);
    }
    /* user-agent 示例
        Android:
        Mozilla/5.0 (Linux; Android 10; V2005A Build/QP1A.190711.020; wv) AppleWebKit/537.36 (KHTML, like Gecko)
        Version/4.0 Chrome/86.0.4240.99 XWEB/4263 MMWEBSDK/20220604 Mobile Safari/537.36 MMWEBID/7335
        MicroMessenger/8.0.24.2180(0x2800183F) WeChat/arm64 Weixin NetType/WIFI Language/zh_CN ABI/arm64 Luggage
        iOS:
        Mozilla/5.0 (iPhone; CPU iPhone OS 14_3 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko)
        Mobile/15E148 MicroMessenger/8.0.21(0x18001505) NetType/WIFI Language/zh_CN
    */
    const versionReg = /MicroMessenger\/([\d\.]+)(?:\((0x[0-9a-fA-F]+)\))?/i;
    const match = versionReg.exec(ua);
    if (!match) {
        return 0;
    }
    if (match[2]) {
        // 优先去小括号后面的版本号，精确到patch包版本
        return Number(match[2]);
    }
    // 取不到的话，根据客户端版本 clientVersion 来转换
    return version2HexVersion(match[1], platform);
}

/*
    @desc   对比两个微信版本(16进制)
    hexVersion > hexVersionNext  -> 返回 大于0的数
    hexVersion = hexVersionNext  -> 返回 等于0
    hexVersion < hexVersionNext  -> 返回 小于0的数
*/
_aoExports.hexVersionCompare = function(hexVersion = 0, hexVersionNext = 0) {
    return hexVersion - hexVersionNext;
}

/* 统一获取当前网络  */
_aoExports.getNetworkType = function() {
    //Mozilla/5.0 (iPhone; CPU iPhone OS 9_0_2 like Mac OS X) AppleWebKit/601.1.46 (KHTML, like Gecko) Mobile/13A452 MicroMessenger/6.3.23 NetType/4G Language/zh_CN
    var tp = '',
        mp = {
            'wifi'      : 0,
            'uninet'    : 2,
            'uniwap'    : 2,
            'cmnet'     : 2,
            'cmwap'     : 2,
            'ctnet'     : 2,
            'ctwap'     : 2,
            '2g'        : 2,
            '3g'        : 3,
            '3gnet'     : 3,
            '3gwap'     : 3,
            'nonwifi'   : 3,
            '4g'        : 4,
            'lte'       : 4,
            'ctlte'     : 4,
            '3g+'       : 4,
            '4gnet'     : 4,

            // jscore内的map
            'NON_NETWORK': 1,
            'WIFI'       : 0,
            '5G'         : 5,
            '4G'         : 4,
            '3G'         : 3,
            '2G'         : 2
        };
    // 0:  wifi, 1: unknown , 2: 2g, 3: 3g, 4: 4g, 5:5g
    if(!mbase.isCSR) {
        var mat = (Dom.window.navigator.userAgent || Dom.window.navigator.wxuserAgent).match(/NetType\/[^\s]+/i);
        if (mat && mat.length >= 1) {
            tp = mat[0].split('/')[1].toLowerCase();
        }
    }else{
        tp = mbase.getCSR().getSystemInfo().networkType;
    }
    if (tp in mp) {
        return mp[tp] + '';
    } else {
        return 1 + '';
    }
};

_aoExports.isWepkgInUrl = function(){
    var isInUrl = !!getQueryStr('wechat_pkgid',null,Dom.window);
    return isInUrl;
};
/**
 * 判断当前版本，是不是运行在wepkg里。
 *
 * @returns true || false
 */
_aoExports.isWepkg      = function(){
    if(mbase.isCSR) return false;

    var isInUrl = this.isWepkgInUrl();

    var clientVersion = this.clientVersion( true );
    var bigger659 = this.versionCompare(clientVersion,'6.5.9') >= 0 ;
    if( bigger659 )
    {
        /*
        * @desc 在6.5.9版本里，会有这个变量注入。
        */
        var __usewepkg__ = Dom.window.__usewepkg__;
        if( undefined != __usewepkg__ ){

            return !!__usewepkg__ && isInUrl;
        }else{
            return false;
        }
    }else{
        /*
        * @desc 否则的话，还是用老方法判断是不是在wepkg里。
        */

        /*
        * @desc 如果是安卓，大于等于6.5.6才可以,ios只有6.5.8及以上版本才有wepkg。
        */
        var osCanUse = false;
        var clientVersion = this.clientVersion( true );

        var osVersionCanUse = this.isAndroid ? '6.5.6':'6.5.8';
        osCanUse  = this.versionCompare(clientVersion,osVersionCanUse) >= 0;

        return osCanUse && isInUrl;
    }
};

/*
*  这个判断逻辑有点过时，可以直接用 Env.isMiniprogram()
*   判断页面是否在小程序中
*/
function getIsInMiniAppAsync( callback ) {
    if(mbase.isCSR) return false;

    var flag_1 = Dom.window.__wxjs_environment,
        flag_2 = Dom.window.navigator.userAgent || '';
    var timer;

    if ( (flag_1 || flag_2) ) {
        var ret = (flag_1 === 'miniprogram') || ( flag_2.indexOf('miniprogram') != -1 );
        callback(ret);
    } else {

        if ( typeof callback == 'function' ) {
            Dom.window.document.addEventListener('WeixinJSBridgeReady', function() {
                if ( timer ) {
                    clearTimeout(timer);
                    timer = null;
                }
                callback( Dom.window.__wxjs_environment === 'miniprogram' );
            }, false)
        }

        // 两秒后不执行上面的回调就走下面的定时器
        timer = setTimeout(function() {
            callback && callback(false);
        }, 2000);
    }

}
_aoExports.getIsInMiniAppAsync = getIsInMiniAppAsync;
let _isMiniprogram = null;
_aoExports.isMiniprogram = () => {
    if( _isMiniprogram === null ) {
        if(mbase.isCSR) {
            _isMiniprogram = false;
        }else {
            if( Dom.window.__wxjs_environment === 'miniprogram') {
                _isMiniprogram = true;
            }else {
                _isMiniprogram = /miniprogram/i.test(Dom.window.navigator.userAgent)
            }
        }
    }
    return _isMiniprogram;
}

// 是否是小游戏场景
let _isMinigame = null; // 加个缓存
_aoExports.isMinigame = () => {
    if( _isMinigame === null ) {
        _isMinigame = _aoExports.isMiniprogram() && (+getQueryStr("AppServiceType") === 4)
    }
    return _isMinigame;
}

_aoExports.canIReport = function() {
    return window?.WXGAME?.GlobalConfig?.reporter?.canIReport?.() ?? true;
}

let pageScene
_aoExports.getScene = () => {
    return pageScene;
}
_aoExports.setScene = (value) => {
    pageScene = value;
}
_aoExports.getBottomTabHeight = () => {
    return window?.wgclient?.__gameTabHeight__ || 57;
}

_aoExports.isIframe = () => {
    try {
        return window.self !== window.top;
    } catch (e) {
        return false;
    }
}

_aoExports.getSystemInfo = () => {
    // 先不加缓存，临时方案，后面根据上报数据修正
    let tabBarHeight = window?.wgclient?.__gameTabHeight__ ?? 57;
    let navigationBarHeight = window?.wgclient?.__gameTopBarHeight__ ?? 88;
    if ( _aoExports.isIframe() ) { // iframe
        return {
            pixelRatio: window.devicePixelRatio,
            windowWidth: document.documentElement.clientWidth || window.innerWidth,
            windowHeight: document.documentElement.clientHeight || window.innerHeight,
            navigationBarHeight: navigationBarHeight,
            tabBarHeight: tabBarHeight
        }
    }
    // 通过数据上报发现，screen.width会存在一些401、341等奇怪的数值（比例在9%左右），而clientWidth这种比较奇怪数值占比比较少（不到1%）。现有clientWidth不兼容导致获取不到的比例为0.4%。综合考虑，优先级document.documentElement.clientWidth > window.screen.width >  window.innerWidth
    return {
        pixelRatio: window.devicePixelRatio,
        windowWidth: document.documentElement.clientWidth || window.screen.width || window.innerWidth, 
        windowHeight: document.documentElement.clientHeight || window.screen.height || window.innerHeight,
        navigationBarHeight: navigationBarHeight,
        tabBarHeight: tabBarHeight
    }
}

_aoExports.isBanTransform = (banSystemVersion = 145) => {
    let systemMsg = navigator.userAgent;

    if (systemMsg.indexOf('iPhone') !== -1) {
        // ios 14.5 以上 && wechat 8.7.0 禁用
        systemMsg = systemMsg.toLowerCase();

        const systemVersionReg = /cpu iphone os (.*?) like mac os/;
        const systemVersionMsg = systemMsg.match(systemVersionReg).length && systemMsg.match(systemVersionReg)[1];
        const systemVersionList = systemVersionMsg.split('_');
        const systemVersion = Number(systemVersionList[0] + systemVersionList[1]);
        const clientVersion = _aoExports.clientVersion(true);
        const isInCilentVersion = _aoExports.versionCompare(clientVersion, '8.0.7') >= 0;

        return systemVersion >= banSystemVersion && isInCilentVersion;
    }

    return false;
}

// 判断是否支持全屏透明顶
_aoExports.isImmersive = () => {
    if (getQueryStr('wechat_immersive') !== '1') return false;

    const currentVersion = _aoExports.clientVersion(true);
    if (_aoExports.isiOS && _aoExports.versionCompare(currentVersion, '7.0.15') >= 0) {
        if (typeof window.wgclient?.__isGameCenterScene__ !== 'undefined') {
            return !!window.wgclient?.__isGameCenterScene__;
        }
        return true;
    }
    if (_aoExports.isAndroid && _aoExports.versionCompare(currentVersion, '7.0.17') >= 0) {
        return true;
    }

    return false;
};

// 非vue版本判断是否是适老化模式
_aoExports.initAccessibilityModeListener = () => {
    let initFontSize = 2;
    let initFontScale = 100;
    
    const sizeMap = {
        2: 1,
        3: 1.1,
        4: 1.12,
        5: 1.125,
        6: 1.4,
        7: 1.4,
        8: 1.4
    }
    
    function appendAccessibilityMode(size, scale) {
        if(!window.wgclient) {
            window.wgclient = {}
        }
    
        document.body.classList.add('wg_accessibility_mode');
    
        if(scale) {
            setFontSize(scale);
        }else {
            document.documentElement.style.setProperty('--font-scale', sizeMap[size] || 1);
            window.wgclient.__currentFontScale = sizeMap[size];
        }
    }
    
    function setFontSize(scale) {
        if(!window.wgclient) {
            window.wgclient = {}
        }
    
        document.documentElement.style.setProperty('--font-scale', scale / 100);
        if(_aoExports.isiOS) {
            document.body.style.webkitTextSizeAdjust = (scale + '%');
            document.body.style.textSizeAdjust = (scale + '%');
        }
    
        window.wgclient.__currentFontScale = scale / 100;
    }
    
    function removeAccessibilityMode() {
        document.body.classList.remove('wg_accessibility_mode');
    }

    if(_aoExports.isiOS) {
        WXGAME.WxBridge.verifyJsapi(['getUserConfig'], (res) => {
            WXGAME.WxBridge.invoke('getUserConfig', {}, (res) => {
                // 是关怀模式
                if(res && res.isAccessibilityMode) {
                    res.fontSize = res.fontSize || 7;
                    res.fontScale = res.fontScale || 140
                    appendAccessibilityMode(res.fontSize, res.fontScale);
                }
            })
        })

        // ios通过jsapi获取
        WXGAME.WxBridge.on('menu:setfont', (res) => {
            if(res && res.fontSize) {
                initFontSize = res.fontSize;
                initFontScale = res.fontScale;
            }

            if(res && res.fontSize > 4) {
                appendAccessibilityMode(res.fontSize, res.fontScale);
            }else {                                    
                removeAccessibilityMode();
                setFontSize(res.fontScale || 100);
            }
        })
    }else {
        // 如果安卓设置了字体大于标准字体
        if(window?.wgclient && window?.wgclient.__currentFontSize__) {
            // 安卓字体值为1-8，大于标准字体认为开了
            if(window.wgclient.__currentFontSize__ > 4) {
                appendAccessibilityMode(window.wgclient.__currentFontSize__);
            }else {
                setFontSize(initFontScale || 100);
            }
        }
    }
}


_aoExports.canPreInjectDataUse = () => {
  if( _aoExports.isCSR ) {
    return false;
  }
  const currentVersion = _aoExports.clientVersion(true);
  if (_aoExports.isiOS && _aoExports.versionCompare(currentVersion, '8.0.0') >= 0) {
    return true;
  }
  if (_aoExports.isAndroid && _aoExports.versionCompare(currentVersion, '8.0.0') >= 0) {
    return true;
  }
  return false;
}

let preInjectDataCache;
_aoExports.getPreInjectData = () => {
  if( _aoExports.isCSR ) {
    return;
  }
  if (preInjectDataCache) {
    return preInjectDataCache;
  }
  let preInjectData;
  if ( _aoExports.canPreInjectDataUse() ) {
    preInjectData = window.wgclient?.__gamePreInjectData__;
  } else {
    const key = getQueryStr('pij_d_k');
    if (key) {
      const storeKey = `pij_d_k_${key}`;
      preInjectData = localStorage.getItem(storeKey);
      localStorage.removeItem(storeKey);
    }
  }
  if (preInjectData) {
    try {
      preInjectData = JSON.parse(preInjectData);
    } catch (e) {}
  }
  preInjectDataCache = preInjectData;
  return preInjectData;
}

// 是否半屏
_aoExports.isHalfScreen = () => {
    let wxWebEnv = window.__wxWebEnv?.getEnv?.();
    if( wxWebEnv ) {
        try {
            wxWebEnv = JSON.parse(wxWebEnv);
        }catch(err) {}
        let heightPercent = wxWebEnv?.heightPercent || 0;
        // 判断高度百分比
        if (heightPercent > 0 && heightPercent < 1 ) {
            return true;
        }
    }
    return false;
}

let _isRealName = getQueryStr("is_real_name") ? !!getQueryStr("is_real_name") : true;
_aoExports.setRealName = (isRealName = true) => {
    _isRealName = isRealName;
}

_aoExports.isRealName = () => {
    return _isRealName
}   

_aoExports.onRealNameRequestFns = [];

// 未实名点击小游戏回调
_aoExports.onRealNameRequest = (callback) => {
    _aoExports.onRealNameRequestFns.push(callback);
}

if(!_aoExports.isCSR) {
    let win = window;
    if ( win['WXGAME'] && win['WXGAME'].Env) {
        _aoExports = win['WXGAME'].Env;
    }
}

_aoExports.getGameSessionId = () => {
    if( _aoExports.isCSR ) {
        return ''
    }
    return window.wgclient?.__report_session_id__ || ''
}


export default _aoExports;
